export const blockIconsUiactionsRadioButtonCheckedNew = (
	<span className='material-symbols-outlined'>radio_button_checked</span>
);
